<div class="new-email-container">

  <div class="header">
    <div fiTranslation="BUTTON_DUPLICATE_SAVE_ADDITIONAL_CONTACT1"></div>
    <fi-button
      variant="tertiary"
      tone="neutral"
      size="lg"
      [iconOnly]="true"
      (click)="closeDialog()"
    >
      <mat-icon fiButtonIcon>close</mat-icon>
      <span fiTranslation="ALT_TEXT_DIALOG_CLOSE"></span>
    </fi-button>
  </div>

  <div class="main-container">

    <div class="main-content">
      <div class="dialog-field">
        <div class="description">
          <div fiTranslation="ACTION_DUPLICATE_CHECK_SAVE_ADDITIONALLY_HEADER"></div>
        </div>
        <form [formGroup]="emailForm">
          <div class="form-field">
            <label>
              <div class="email-text-and-error-message">
                <span class="label" fiTranslation="FORM_HEADLINE_E-MAIL"></span>
              </div>
              <input maxlength="500" type="email" formControlName="Email" class="form-input" #emailField
                [class.invalid]="hasEmailErrors"
                >
            </label>
          </div>

          @if (emails) {
            <div class="form-field">
              <label>
                <span class="label additional-label" fiTranslation="REQUEST_CREATE_CONTACT_EXTRA_EMAIL"></span>
                <input maxlength="500" type="email" formControlName="AdditionalEmail" class="form-input"
                  [class.invalid]="isInvalidForm('AdditionalEmail')">
              </label>
            </div>
          }
          <div class="mail-cont" (click)="addEmail()">
            <span class="email-icon" #secondEmail [isTitle]="true" fiTranslation="ALT_TEXT_SECOND_EMAIL"
              matTooltip="{{secondEmail.dataset.matTooltip}}" matTooltipPosition="below" matTooltipClass='tooltip-style'>
              <svg xmlns="http://www.w3.org/2000/svg" width="27.844" height="21.549" viewBox="0 0 27.844 21.549">
                <g id="email_" data-name="email+" transform="translate(4569.15 20558.15)">
                  <g id="Group_2302" data-name="Group 2302">
                    <g id="email_2" data-name="email +">
                      <path id="Path_620" data-name="Path 620" class="mail-path fi-fill-secondary-default fi-stroke-secondary-default"
                        d="M17.775,64.1H.225A.231.231,0,0,0,0,64.335V76.861a.231.231,0,0,0,.225.237h17.55A.231.231,0,0,0,18,76.861V64.335A.231.231,0,0,0,17.775,64.1Zm-.6.473L9.709,72.218a.988.988,0,0,1-1.419,0L.821,64.571ZM.45,64.851l5.86,6L.45,76.4ZM.884,76.625l5.75-5.444,1.343,1.375a1.425,1.425,0,0,0,2.047,0l1.273-1.3,5.877,5.372Zm16.666-.283-5.93-5.42,5.93-6.071Z"
                        transform="translate(-4569 -20622.098)" stroke-width="0.3"/>
                      <g id="Group_1917" data-name="Group 1917" transform="translate(-104 -176)">
                        <path id="Path_318" data-name="Path 318"
                          d="M293.017,290.232h-3.164l1.224-1.289a.558.558,0,0,0-.809-.768l-2.117,2.231a.572.572,0,0,0-.042.068c-.009.012-.017.024-.025.037a.579.579,0,0,0-.04.06s0,.009,0,.014a.523.523,0,0,0-.021.1.588.588,0,0,0-.019.1s0,.005,0,.008,0,0,0,.007a.542.542,0,0,0,.019.1.558.558,0,0,0,.021.1.127.127,0,0,0,0,.014.552.552,0,0,0,.04.059c.008.013.017.025.026.038a.587.587,0,0,0,.042.068l2.117,2.231a.557.557,0,0,0,.788.021.558.558,0,0,0,.021-.789l-1.223-1.29h3.164a.558.558,0,0,0,0-1.116Z"
                          transform="translate(-4735.688 -20659.271)" class="fi-fill-invert-primary"/>
                        <g id="Group_2304" data-name="Group 2304">
                          <g id="Group_2303" data-name="Group 2303">
                            <g id="Path_331" data-name="Path 331" transform="translate(-4450.806 -20374.102)" class="fi-fill-secondary-default">
                              <path
                                d="M 5.5 12.25 C 1.778040051460266 12.25 -1.25 9.221960067749023 -1.25 5.5 C -1.25 1.778040051460266 1.778040051460266 -1.25 5.5 -1.25 C 9.221960067749023 -1.25 12.25 1.778040051460266 12.25 5.5 C 12.25 9.221960067749023 9.221960067749023 12.25 5.5 12.25 Z"
                                stroke="none"/>
                              <path class="plus-path fi-fill-invert-primary"
                                d="M 5.5 0 C 2.462430000305176 0 0 2.462430000305176 0 5.5 C 0 8.537569999694824 2.462430000305176 11 5.5 11 C 8.537569999694824 11 11 8.537569999694824 11 5.5 C 11 2.462430000305176 8.537569999694824 0 5.5 0 M 5.5 -2.5 C 9.911210060119629 -2.5 13.5 1.088789939880371 13.5 5.5 C 13.5 9.911210060119629 9.911210060119629 13.5 5.5 13.5 C 1.088789939880371 13.5 -2.5 9.911210060119629 -2.5 5.5 C -2.5 1.088789939880371 1.088789939880371 -2.5 5.5 -2.5 Z"
                                stroke="none"/>
                            </g>
                            <path class="plus-path fi-fill-invert-primary" id="Path_621" data-name="Path 621"
                              d="M4.5,0A4.5,4.5,0,1,1,0,4.5,4.5,4.5,0,0,1,4.5,0Z"
                              transform="translate(-4449.806 -20373.102)"/>
                          </g>
                          <g id="Group_2301" data-name="Group 2301" transform="translate(0 1)">
                            @if (!emails) {
                              <g id="Path_809" data-name="Path 809" transform="translate(-4446 -20372)"
                                class="fi-fill-invert-primary">
                                <path d="M 0.5 4.5 L 0.5 0.5 L 0.5 4.5 Z" stroke="none"/>
                                <path d="M 0 0 L 1 0 L 1 5 L 0 5 L 0 0 Z" stroke="none" class="fi-fill-secondary-default"/>
                              </g>
                            }
                            <g id="Path_810" data-name="Path 810" transform="translate(-4443 -20370) rotate(90)" class="fi-fill-invert-primary">
                              <path d="M 0.5 4.5 L 0.5 0.5 L 0.5 4.5 Z" stroke="none"/>
                              <path d="M 0 0 L 1 0 L 1 5 L 0 5 L 0 0 Z" stroke="none" class="fi-fill-secondary-default"/>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </span>
            <span class="mail-text" fiTranslation="FORM_HEADLINE_ADDITIONAL_E-MAIL"></span>
          </div>
        </form>

      </div>

      <div class="submit-container">
        <div (click)="backDialog()" class="back-button">

          <div class="arrow">
            <img src="/assets/icons/arrow-right.svg" alt="arrow">
          </div>
          <div class="text">
            <span class="mobile" fiTranslation="BUTTON_BACK"></span>
            <span class="desktop" fiTranslation="BUTTON_BACK_TO_DUPLICATE_CHECK"></span>
          </div>

        </div>
        <div class="submit-btn" (click)="submit()">
          <img [src]="iconUrl" alt="save" class="icon">
          <span class="text" fiTranslation="BUTTON_DUPLICATE_SAVE_ADDITIONAL_CONTACT1"></span>
        </div>

      </div>

    </div>
  </div>

</div>

